<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center block-step block-fullscreen-text">
      <h1 class="title-section">EXPERIÊNCIA DO CLIENTE</h1>
      <div class="title-main">
        <p>O conceito de experiência do cliente é amplamente abordado na jornada de transformação digital. A maioria das ações que fazemos nas empresas tem como finalidade as pessoas. Logo elas assumem um papel central quando são consideradas nossos clientes.</p>
        <p>Sendo o cliente todo aquele que consome o seu produto e/ou serviço, vamos conferir algumas questões relevantes desse cenário.</p>
      </div>
      <router-link :to="nextScreen" class="nav-arrow-down">
        <div class="title hidden-sm">
          Role para baixo
        </div>
        <icon name="arrow-line-right" class="arrow-right animation-blink" />
      </router-link>
    </section>
  </div>
</template>

<script>
import Icon from '../Icon';
import rollDown from '../mixins/rollDown';

/* eslint-disable max-len */
export default {
  name: 'experiencia_do_cliente',
  mixins: [rollDown],
  components: { Icon },
  data() {
    return {
      nextScreen: '/teste/experiencia-do-cliente/formulario',
    };
  },
  mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 5);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/test/CustomerExperience.vue